export default __webpack_public_path__ + "static/media/illustration_benefit2.74c55305.png";